import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { WHATSAPP_URL, APP_URL } from "./shared";

const NAV = [
  { label: "Plataforma", to: "/", testId: "footer-link-plataforma" },
  { label: "Método", to: "/metodo", testId: "footer-link-metodo" },
  { label: "Como funciona", to: "/como-funciona", testId: "footer-link-como-funciona" },
  { label: "Diferenciais", to: "/diferenciais", testId: "footer-link-diferenciais" },
];

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-white/[0.07] bg-tria-navy/70">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-5 max-w-sm text-[13.5px] leading-relaxed text-tria-mist">
            Gestão gerencial e inteligência financeira para varejo e brechós.
            Custos × Margem × Faturamento — em uma única visão.
          </p>
        </div>

        <div>
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-tria-subtle">Navegação</p>
          <ul className="mt-5 space-y-3">
            {NAV.map((l) => (
              <li key={l.to}>
                <Link
                  data-testid={l.testId}
                  to={l.to}
                  className="text-[13.5px] font-medium text-tria-mist transition-colors hover:text-tria-sky"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-tria-subtle">Acesso</p>
          <ul className="mt-5 space-y-3">
            <li>
              <a data-testid="footer-link-login" href={APP_URL} target="_blank" rel="noopener noreferrer" className="text-[13.5px] font-medium text-tria-mist transition-colors hover:text-tria-sky">
                Login
              </a>
            </li>
            <li>
              <a data-testid="footer-link-signup" href={APP_URL} target="_blank" rel="noopener noreferrer" className="text-[13.5px] font-medium text-tria-mist transition-colors hover:text-tria-sky">
                Criar conta
              </a>
            </li>
            <li>
              <a data-testid="footer-link-demo" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-[13.5px] font-medium text-tria-mist transition-colors hover:text-tria-sky">
                Agendar demonstração
              </a>
            </li>
            <li>
              <a data-testid="footer-link-contact" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-[13.5px] font-medium text-tria-mist transition-colors hover:text-tria-sky">
                Contato
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/[0.06] pt-8 sm:flex-row">
        <p className="text-[12px] text-tria-subtle">
          © {new Date().getFullYear()} TRIA. Todos os direitos reservados.
        </p>
        <p data-testid="footer-credit" className="text-[12px] font-medium text-tria-subtle">
          Developed by <span className="text-tria-mist">Sapientia Consultores Associados</span>
        </p>
      </div>
    </div>
  </footer>
);
